import { t } from 'i18next'
import { toast } from 'react-toastify'

export const NotifyError = (message?: string) => {
  if (message && message?.includes('.')) return toast.error(t(message))
  return toast.error(t('error.not.completed'))
}
